import { render, staticRenderFns } from "./ButtonDanger.vue?vue&type=template&id=a2c262bc&scoped=true"
import script from "./ButtonDanger.vue?vue&type=script&lang=ts"
export * from "./ButtonDanger.vue?vue&type=script&lang=ts"
import style0 from "./ButtonDanger.vue?vue&type=style&index=0&id=a2c262bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c262bc",
  null
  
)

export default component.exports